import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '@components/modal/modal.component';
import {StyledFooter} from '@components/pane/pane.style';
import Form from '@components/form'
import {useForm} from 'react-hook-form';
import {StyledModalContent} from '@components/modal/modal.style';
import {StyledButton, StyledWiteButton} from "@components/button/button.style";
import {disableSwipeToClose} from "@utils/tools/modals";
import {Preferences} from "@capacitor/preferences";

type SaveConfirmationModalProps = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

type ConfirmationModalInfoDataProps = {
    firstName: string;
    lastName: string;
}

const SaveConfirmationModal: React.FC<SaveConfirmationModalProps> = (props: SaveConfirmationModalProps) => {
    const {t} = useTranslation();
    const {handleSubmit} = useForm({
        mode: 'onChange'
    });

    const [showModal, updateShowModal] = useState<boolean>(false);
    const [confirmationModalInfoData, setConfirmationModalInfoData] = useState<ConfirmationModalInfoDataProps>();

    useEffect(() => {
        handleOpen();
    }, [props.isOpen]);

    useEffect(() => {
        handleConfirmationModalInfoData();
    }, []);

    const handleConfirmationModalInfoData = async () => {
        const userFirstname = await Preferences.get({'key': 'first_name'});
        const userLastname = await Preferences.get({'key': 'last_name'});

        if (userFirstname.value && userLastname.value) {
            setConfirmationModalInfoData({
                firstName: userFirstname.value,
                lastName: userLastname.value,
            })
        }
    }

    const handleCancel = () => {
        updateShowModal(false);
        props.onCancel();
    };

    const handleSign = () => {
        updateShowModal(false);
        props.onConfirm();
    };

    const handleOpen = () => {
        updateShowModal(props.isOpen);
    };

    return (
        <Modal
            isOpen={showModal}
            canDismiss={disableSwipeToClose}
            disableClose={true}
            onDidDismiss={() => {}}>
            <Form.Container className="modalForm" onSubmit={handleSubmit(handleSign)}>
                <StyledModalContent>
                    <h1 className="title">{t("myData.saveConfirmation.title")}</h1>
                    <div className="content">
                        <p>
                            {t("myData.saveConfirmation.statement", {
                                firstName: confirmationModalInfoData?.firstName,
                                lastName: confirmationModalInfoData?.lastName,
                            })}
                        </p>
                    </div>
                    <StyledFooter className="modal footer no-shadow">
                        <StyledWiteButton type="button" onClick={handleCancel}>{t("myData.cancel")}</StyledWiteButton>
                        <StyledButton type="submit">{t("myData.confirm")}</StyledButton>
                    </StyledFooter>
                </StyledModalContent>
            </Form.Container>
        </Modal>
    );
};

export default SaveConfirmationModal;